/* THRIFT AVE — gift lines always quantity 1 (21/10/2026)
 * Order #1056 went through with 4 free caps on 2 boxes: Shrine's gift engine adds the gift
 * when the cart unlocks it but never caps the quantity, and on /cart the gift line had +/-.
 * After every cart write (add/change/update) and on page load this reads /cart.js and puts any
 * free regalo-* line above 1 back to 1, then re-renders the drawer (or reloads /cart).
 * Removing a gift stays the engine's job (it removes it when the cart is locked again).
 */
(function () {
  'use strict';
  if (window.__taGiftOne) return;
  window.__taGiftOne = true;

  var nativeFetch = window.fetch.bind(window);
  var timer = null;
  var running = false;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function isGift(item) {
    return item && item.handle && item.handle.indexOf('regalo-') === 0 && Number(item.original_price) === 0;
  }

  function onCartPage() {
    return /\/cart\/?$/.test(window.location.pathname);
  }

  function fix() {
    if (running) return;
    running = true;
    nativeFetch(root() + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var extra = (cart.items || []).filter(function (it) { return isGift(it) && it.quantity > 1; });
        if (!extra.length) return null;
        /* one line at a time: /cart/change.js by line key */
        return extra.reduce(function (p, it) {
          return p.then(function () {
            return nativeFetch(root() + 'cart/change.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: it.key, quantity: 1, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
            }).then(function (r) { return r.json(); });
          });
        }, Promise.resolve());
      })
      .then(function (state) {
        if (!state) return;
        if (onCartPage()) { window.location.reload(); return; }
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function' && state.sections) drawer.renderContents(state, true);
        try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: state, source: 'ta-gift-one' } })); } catch (e) {}
      })
      .catch(function () {})
      .then(function () { running = false; });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(fix, 600); /* after the engine's own add has landed */
  }

  /* every cart write from the theme, the gift engine or the apps goes through fetch */
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (/\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url)) {
      p.then(schedule, schedule);
    }
    return p;
  };

  /* last guard before paying: the checkout button waits for the fix */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[name="checkout"], a[href$="/checkout"], button[form="CartDrawer-Form"]');
    if (!btn || btn.__taGiftOk) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    clearTimeout(timer);
    running = false;
    nativeFetch(root() + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var bad = (cart.items || []).filter(function (it) { return isGift(it) && it.quantity > 1; });
        return bad.reduce(function (p, it) {
          return p.then(function () {
            return nativeFetch(root() + 'cart/change.js', {
              method: 'POST', credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: it.key, quantity: 1 })
            });
          });
        }, Promise.resolve());
      })
      .catch(function () {})
      .then(function () { btn.__taGiftOk = true; btn.click(); });
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix);
  else fix();
})();
